const environments = require('./.env.json');

module.exports = {
  backendUrl: environments.BACKEND_URL,
  socketUrl: environments.SOCKET_URL,
  collaborativeWsUrl: environments.WS_COLLABORATIVE_EDITOR_URL,
  httpsCollaborativeWsUrl: environments.HTTPS_COLLABORATIVE_EDITOR_URL,
  apiBase: environments.BACKEND_URL + 'api',
  localServer: environments.NODE_TLS_REJECT_UNAUTHORIZED,
  test: environments.TEST,
  mixpanelToken: environments.MIXPANEL_TOKEN,
  frontendHostUrl: environments.FRONTEND_HOST_URL,
  ghostContentApiKey: environments.GHOST_CONTENT_API_KEY,
  blogUrl: environments.BLOG_URL,
  sentryDSN: environments.SENTRY_DSN,
  sentryEnvironment: environments.SENTRY_ENVIRONMENT,
  cannyAppId: environments.CANNY_APP_ID,
  googleClientId: environments.GOOGLE_CLIENT_ID,
  documentSaveMode: environments.DOCUMENT_SAVE_MODE,
  liveblocksPublicKey: environments.LIVEBLOCKS_PUBLIC_KEY,
  openAIKey: environments.OPENAI_API_KEY,
  googleClientSecret: environments.GOOGLE_CLIENT_SECRET,
  googleRedirectUri: environments.GOOGLE_REDIRECT_URI,
};
